import { observer } from 'mobx-react-lite'
import React from 'react'
import { useStore } from '../../../../lib/context'
import {
	Container,
	BusinessHeader,
	CollaboratorHeader,
	ResourceHeader,
	ContributorHeader,
	EmailCapture,
} from './'

const Header = observer(({ category, backgroundColor }) => {
	const {uiStore:{community__activeTab}} = useStore();
	const color  = community__activeTab ? community__activeTab.color : "transparent"
	return (
		<>
			{/* {category === 'Resources' && <EmailCapture />} */}
			<Container backgroundColor={color}>
				{category === 'Business' && <BusinessHeader />}
				{category === 'Contributor' && <ContributorHeader />}
				{category === 'Collaborator' && <CollaboratorHeader />}
				{category === 'Resources' && <ResourceHeader />}
			</Container>
		</>
	)
})

export default Header
